/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getProfileInfo} from '../api'

 export const useQueryGetProfileInfo = createReactQueryHook('getProfileInfo', getProfileInfo)
